/**
 * Operations sharing this key run one at a time in the order they were issued, so a stale estimate
 * cannot land last and win the cache.
 */
export const CREDIT_CALCULATION_SERIALIZATION_KEY = 'CREDIT_CALCULATION_SERIALIZATION_KEY';

/** Longer than the link default so a multi-digit amount typed at speed is saved as one write. */
export const CREDIT_CALCULATION_DEBOUNCE_TIMEOUT_MS = 1000;
